import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useLang } from "../i18n/LanguageContext";
import TopBar from "../components/TopBar";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PortalLoginPage() {
  const { t, lang } = useLang();
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [mode, setMode] = useState("token");
  const es = lang === "es";

  const enterWithToken = (e) => {
    e.preventDefault();
    const clean = token.trim().replace(/^.*\/p\//, "").trim();
    if (!clean) return;
    navigate(`/p/${clean}`);
  };

  const enterWithEmail = async (e) => {
    e.preventDefault();
    setError("");
    if (!email.trim()) return;
    try {
      const r = await axios.post(`${API}/portal/lookup`, { email: email.trim() });
      if (r.data.token) navigate(`/p/${r.data.token}`);
      else setError(es ? "No encontramos ese correo." : "Email not found.");
    } catch {
      setError(es ? "No encontramos ese correo." : "Email not found.");
    }
  };

  return (
    <div className="min-h-screen bg-[#080808] text-white">
      <TopBar />
      <main className="max-w-md mx-auto px-4 py-16">
        <div className="rounded-2xl bg-[#161616] border border-[#252525] p-8">
          <div className="text-3xl mb-3">🔒</div>
          <h1 className="font-bebas text-3xl tracking-widest">
            {es ? "PORTAL DE PADRES" : "PARENT PORTAL"}
          </h1>
          <p className="text-sm text-neutral-400 mb-6">
            {es ? "Accede al perfil privado de tu hijo/a." : "Access your child's private profile."}
          </p>

          <div className="flex gap-1.5 mb-5 border-b border-[#252525]">
            <button
              onClick={() => setMode("token")}
              data-testid="mode-token"
              className={`px-3 py-2 -mb-px text-sm border-b-2 transition-colors ${mode === "token" ? "text-[#e8559a] border-[#e8559a]" : "text-neutral-400 border-transparent"}`}
            >
              {es ? "Con mi link" : "With my link"}
            </button>
            <button
              onClick={() => setMode("email")}
              data-testid="mode-email"
              className={`px-3 py-2 -mb-px text-sm border-b-2 transition-colors ${mode === "email" ? "text-[#e8559a] border-[#e8559a]" : "text-neutral-400 border-transparent"}`}
            >
              {es ? "Con mi email" : "With my email"}
            </button>
          </div>

          {mode === "token" ? (
            <form onSubmit={enterWithToken} className="space-y-3">
              <label className="block text-xs uppercase tracking-wider text-neutral-500">
                {es ? "Link único (del email de bienvenida)" : "Unique link (from welcome email)"}
              </label>
              <input
                value={token}
                onChange={(e) => setToken(e.target.value)}
                placeholder="https://.../p/abc123..."
                data-testid="portal-token-input"
                className="w-full bg-[#0f0f0f] border border-[#252525] rounded-lg px-4 py-3 text-white text-sm focus:border-[#e8559a] focus:outline-none"
              />
              <button
                type="submit"
                data-testid="portal-enter-token"
                className="w-full px-5 py-3 rounded-xl bg-[#e8559a] hover:bg-[#c9407f] text-white font-bebas text-lg tracking-widest transition-colors"
              >
                {es ? "ENTRAR" : "ENTER"} →
              </button>
            </form>
          ) : (
            <form onSubmit={enterWithEmail} className="space-y-3">
              <label className="block text-xs uppercase tracking-wider text-neutral-500">
                {es ? "Email registrado" : "Registered email"}
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="parent@email.com"
                data-testid="portal-email-input"
                className="w-full bg-[#0f0f0f] border border-[#252525] rounded-lg px-4 py-3 text-white text-sm focus:border-[#e8559a] focus:outline-none"
              />
              {error && <div className="text-[#e05555] text-sm">{error}</div>}
              <button
                type="submit"
                data-testid="portal-enter-email"
                className="w-full px-5 py-3 rounded-xl bg-[#e8559a] hover:bg-[#c9407f] text-white font-bebas text-lg tracking-widest transition-colors"
              >
                {es ? "ENTRAR" : "ENTER"} →
              </button>
            </form>
          )}

          <p className="text-xs text-neutral-500 mt-5 text-center">
            {es
              ? "¿No tienes acceso? Registra a tu jugador primero."
              : "No access yet? Register your player first."}
          </p>
        </div>
      </main>
    </div>
  );
}
